
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"4 4 43 43"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M24.906 3.969c-.043.008-.086.02-.125.031A1.002 1.002 0 0024 5v6c-.004.36.184.695.496.879.313.18.695.18 1.008 0 .312-.184.5-.52.496-.879V5a1 1 0 00-1.094-1.031zm-14.25 5.875a.994.994 0 00-.781.703c-.105.367.004.758.281 1.015l4.25 4.25c.242.297.63.434 1.004.348.371-.086.664-.379.75-.75a1.004 1.004 0 00-.348-1.004l-4.25-4.25a1.004 1.004 0 00-.812-.312h-.094zm28.375 0a1.005 1.005 0 00-.593.312l-4.25 4.25a1.004 1.004 0 00-.348 1.004c.086.371.379.664.75.75.375.086.762-.05 1.004-.348l4.25-4.25a1 1 0 00-.813-1.719zM25 15c-5.516 0-10 4.484-10 10s4.484 10 10 10 10-4.484 10-10-4.484-10-10-10zM4.719 24c-.551.078-.938.59-.86 1.14.079.551.59.938 1.141.86h6c.36.004.695-.184.879-.496a1.01 1.01 0 000-1.008c-.184-.312-.52-.5-.879-.496H4.719zm34 0c-.551.078-.938.59-.86 1.14.078.551.59.938 1.141.86h6c.36.004.695-.184.879-.496a1.01 1.01 0 000-1.008c-.184-.312-.52-.5-.879-.496H38.719zM15 33.875a1.005 1.005 0 00-.594.313l-4.25 4.25a1.004 1.004 0 00-.347 1.003c.086.371.379.664.75.75.375.086.761-.05 1.004-.347l4.25-4.25a1.002 1.002 0 00-.719-1.719H15zm19.688 0a.994.994 0 00-.782.703c-.105.367.004.758.282 1.016l4.25 4.25c.242.297.628.433 1.003.347.371-.086.664-.379.75-.75a1.004 1.004 0 00-.347-1.004l-4.25-4.25a1 1 0 00-.719-.312h-.187zm-9.782 4.094c-.043.008-.086.02-.125.031A1.002 1.002 0 0024 39v6c-.004.36.184.695.496.879.313.18.695.18 1.008 0 .312-.184.5-.52.496-.879v-6a1 1 0 00-1.094-1.031z"}})])
          )
        }
      }
    